import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletContent from 'components/PortletContent';
import 'react-perfcascade/dist/react-perfcascade.css';
// Material components
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import {HarFileView} from 'react-perfcascade';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import {getElements} from '../../../../../services/getElements'
import {getHar} from '../../../../../utils/getHar'
import harData from './example.har';
import harData2 from './example2.har';
import PieStatistics from '../PieStatistics'
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import PerfectScrollbar from 'react-perfect-scrollbar';
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import CloudDownload from '@material-ui/icons/CloudDownload'
import Tooltip from '@material-ui/core/Tooltip';
import { CSVLink,CSVDownload } from "react-csv";
// Component styles
import { Grid } from '@material-ui/core';
import moment from 'moment'
import 'moment/locale/es'
import { TableCell } from '@material-ui/core';
import { single } from 'validate.js';
moment.locale('es')
const dateMoment=((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))



class ElementsPlus extends Component {
    constructor(props) {
        super(props);
        var name=""
        var nameNode=""
        if(typeof(props.overview)==="undefined"){
            name=props.match.params.nombre_objetivo
            nameNode=props.node.titulo
        }else{
            name=props.params.props.objName
            nameNode=props.dataNode.titulo
        }
        this.state = {
            nameObj:name,
            isLoad:true,
            perf:null,
            objective:this.props.objective,
            steps:this.props.steps,
            date:this.props.date,
            node:this.props.node,
            nameNode:nameNode,
            div:<div></div>,
            open: false,
            display:"none",
            divElements:<div></div>,
            openElements: false,
            displayElements:"none",
            data:[]
        };
    }

    componentDidMount() {
        this.processData();
    }

    getFetchs = (objective, steps, date, token, user, monitor) =>{
        //console.log(objective, date, token, user,monitor)
        return new Promise((resolve, reject) => {
            var List = []
            var fetches = []
            steps.forEach((step, key)=>{
                //console.log(key)
                var getData=getElements(objective, monitor, step.id_paso, token, user, date)
                fetches.push(                    
                    getData.then( data =>  { 
                        data["nombre_paso"]=step.nombre_paso
                        List[step.id_paso] = data
                    })                    
                )
            })
            Promise.all(fetches).then(() => {
                resolve(List);
            })      
        });
    }

   
    processData = () => {
        const { objective, steps, date, node}=this.state
        let token = sessionStorage.getItem('key')
        let id_user = sessionStorage.getItem('user')
        var data =this.getFetchs(objective, steps, date.fecha, token, id_user, node.monitor)
        data.then( value=>{
            value.map(step=>{
                if(Object.keys(step).length>3){
                    //console.log('nombre paso', step.nombre_paso)
                    
                    //console.log('ele', step.elementos)
                    var sumatoria=0
                    var descarga=0
                    var eleCount=0
                    var eleOK=0
                    var eleError=0
                    var types_counter = {};
                    var listOK=[]
                    var listError=[]
                    var listExclusion=[]
                    var listRedireccion=[]
                    if(step.elementos.length!==0){
                        step.elementos.map(ele=>{
                            var estado=parseInt(ele.params.estado)
                            if(estado>=200 && estado<300){
                                listOK.push(ele.params)
                            }else if(estado>=300 && estado<400){
                                listRedireccion.push(ele.params)
                            }else if(estado>=400 && estado<1000){
                                listError.push(ele.params)
                            }else if(estado===1000 || estado===1007){
                                listExclusion.push(ele.params)
                            }else{
                                listError.push(ele.params)
                            }
    
                            if (!types_counter.hasOwnProperty(ele.params.tipo)) {
                                types_counter[ele.params.tipo] = 0
                            }
                            types_counter[ele.params.tipo] += 1;
                            var estadoCode=parseInt(ele.params.estado)
                            if(estadoCode===0 || estadoCode>=200 && estadoCode<300 ){
                                eleOK=eleOK+1
                            }else{
                                eleError=eleError+1
                            }
                            sumatoria=sumatoria + parseFloat(ele.params.duracion)
                            if(parseFloat(ele.params.cabecera)!==-1){
                                descarga=descarga + (parseFloat(ele.params.cuerpo)+parseFloat(ele.params.cabecera)) 
                            }else{
                                descarga=descarga + (parseFloat(ele.params.cuerpo))
                            }
                            eleCount=eleCount+1
    
                        })
                        step["listItems"]={"ok":listOK, "error":listError, "exclusion":listExclusion, "redireccion":listRedireccion}
                        step["contador_tipos"]=types_counter
                        step["totalOK"]=parseFloat(eleOK.toFixed(2))
                        step["totalError"]=parseFloat(eleError.toFixed(2))
                        step["eleTotal"]=eleCount
                        step["sumatoria"]=parseFloat(sumatoria.toFixed(2))
                        step["tamanoTotal"]=parseFloat((descarga/1024).toFixed(2))
                        //console.log(step)
                        step["har"]=getHar(step, date, [])
                        //console.log(step.har)
                    }
                    
                }
                
            })
            //console.log('hard', harData)
            //console.log(value)
            this.setState({
                isLoad:false,
                steps:value,
            })
        })
        
    }
    handleClose = event => {
        //const newStep = event.currentTarget.id
        this.setState({
            open: false,
            display:"none"
            //objmodal: newStep
        })
    };

    handleCloseElements = event => {
        //const newStep = event.currentTarget.id
        this.setState({
            openElements: false,
            displayElements:"none"
            //objmodal: newStep
        })
    };
    getStatistics(e, step){
        const {steps}=this.state
        //console.log(steps[e])
        //console.log('fsd', e, step.currentTarget.value )
        var data=e+""+step.currentTarget.value
        //console.log('fssdad', e.currentTarget.id, )
        //console.log('fasdfawdsd', e.target)
        //console.log('sfda', e.target.value)
        this.setState({
            display:"inline",
            open: true,
            //div:<div style={{color:"white"}}>{data}</div>,
            div:<PieStatistics data={steps[e]} />
        })
    }

    getElements(step, date, e){
        if(typeof(step.currentTarget)!=="undefined" && step.currentTarget.id==="csv"){
            var entries=(date.elementos)
            var dataCsv=[]
            entries.map((ele, i)=>{
                var params=ele.params
                var url=params.urlComplete
                var splitUrl=url.split("/")
                var descripcion="ok"
                var esOk="si"
                if(params.estado!=="200"){
                    descripcion=""
                    esOk="no"
                }
                var dict = {id:i,url:url, nombre_corto:splitUrl[splitUrl.length-1], ip:params.ip, "tiempo total descarga (s)":parseFloat(params.duracion)*1000, 
                    "latencia (s)":parseFloat(params.latencia)/1000, "descarga (s)":params.descarga, "tamaño body (bytes)":params.cuerpo, 
                    tipo:params.tipo, codigo_estado:params.estado, es_ok:esOk, descripcion_estado:descripcion}
                dataCsv.push(dict)
            })
            this.setState({
                displayElements:"hidden",
                openElements: false,
                divElements:"",
                data:dataCsv
            })
        }else{
            var grid= <Grid container direction="row" justify="flex-start" alignItems="center" style={{backgroundColor:"white"}}>
                {step.har ?
                <Grid container direction="row"  alignItems="center" id={date.fecha+step.nombre_paso}>
                    <Grid item xs={12}  xl={12} id={date+step.nombre_paso}>
                        <Button title={step.paso_orden} value={date} onClick={this.getStatistics.bind(this,step.paso_orden )}>
                            <Typography >Estadisticas</Typography>
                        </Button>
                    </Grid>
                    <Grid item xs={11}  xl={11}>
                        {this.har(step)}
                    </Grid>
                    <Grid item xs={1}  xl={1} />
                    <Grid item xs={6}  xl={6}>
                        <Typography variant="caption">TIEMPO DESCARGA (SEGS)</Typography>
                    </Grid >
                    <Grid item xs={5}  xl={5} style={{textAlign:"right"}}>
                        <Typography variant="caption">{step.totalTime}</Typography>
                    </Grid >
                    <Grid item xs={1}  xl={1} />
                    <Grid item xs={6}  xl={6}>
                        <Typography variant="caption">SUMATORIA TIEMPOS (SEGS)</Typography>
                    </Grid >
                    <Grid item xs={5}  xl={5} style={{textAlign:"right"}}>
                        <Typography variant="caption">{step.sumatoria}</Typography>
                    </Grid >
                    <Grid item xs={1}  xl={1} />
                    <Grid item xs={6}  xl={6}>
                        <Typography variant="caption">TAMAÑO TOTAL (KB)</Typography>
                    </Grid >
                    <Grid item xs={5}  xl={5} style={{textAlign:"right"}}>
                        <Typography variant="caption">{step.tamanoTotal}</Typography>
                    </Grid >
                    <Grid item xs={1}  xl={1} />
                    <Grid item xs={6}  xl={6} >
                        <Typography variant="caption">TOTAL ELEMENTOS DESCARGADOS</Typography>
                    </Grid >
                    <Grid item xs={5}  xl={5} style={{textAlign:"right"}}>
                        <Typography variant="caption">{step.eleTotal}</Typography>
                    </Grid >
                    <Grid item xs={1}  xl={1} />
                    <Grid item xs={6}  xl={6}>
                        <Typography variant="caption">TOTAL ELEMENTOS DESCARGADOS OK</Typography>
                    </Grid >
                    <Grid item xs={5}  xl={5} style={{textAlign:"right"}}>
                        <Typography variant="caption">{step.totalOK}</Typography>
                    </Grid >
                    <Grid item xs={1}  xl={1} />
                    <Grid item xs={6}  xl={6}>
                        <Typography variant="caption">TOTAL ELEMENTOS DESCARGADOS CON ERROR</Typography>
                    </Grid >
                    <Grid item xs={5}  xl={5} style={{textAlign:"right"}}>
                        <Typography variant="caption">{step.totalError}</Typography>
                    </Grid >
                    <Grid item xs={1}  xl={1} />
                </Grid>
                :<Grid item xs={12}  xl={12} id={date+step.nombre_paso}>
                        <Typography >Sin Informacion</Typography>
                </Grid>
                }
            </Grid>
            
            this.setState({
                displayElements:"inline",
                openElements: true,
                divElements:grid
            })
        }
        
    }

    har=(step)=>{
        var newHar=<div>sin datos</div>
        if(Object.keys(step).length>4){
            newHar=<HarFileView /*harData={harData2}*/ harData={step.har}/>
        }  
        return newHar
    }

    createHar=(date, steps)=>{
        
        const {classes}=this.props
        const {data, nameObj, nameNode}=this.state

        var Har=
            
            steps.map(step=>(
                <ExpansionPanel
                className={classes.backGrey}
                key={date.fecha+step.nombre_paso}
                id={date.fecha+step.nombre_paso}>

                    <ExpansionPanelSummary
                    //expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id={date.fecha+step.nombre_paso}
                    
                    >
                        
                         <Grid container spacing={1} className={classes.padding0}>
                             
                            <Grid item xs={6} md={6} lg={6} className={classes.padding0}>
                                <Button onClick={this.getElements.bind(this,step, date.fecha)} ><Typography className={classes.textWhite}>Detalle elementos | Paso: <b>{step.nombre_paso}</b></Typography></Button>
                            </Grid>
                            {step.har?
                            <Grid item xs={6} md={6} lg={6} style={{textAlign:"center"}} className={classes.padding0}>
                                <Tooltip title="Descarga Csv" placement="top">
                                    <CSVLink id="csv" data={data} filename={nameObj+"_"+nameNode+"_"+date.fecha+"_"+step.nombre_paso+".csv"}
                                        
                                        asyncOnClick={true}
                                        onClick={(event) => {
                                            this.getElements(event, step, date.fecha)
                                        }}>
                                            <CloudDownload className={classes.openCsvIcon} />
                                    </CSVLink>
                                    
                                </Tooltip>
                            </Grid>
                            :<Grid item xs={6} md={6} lg={6} style={{textAlign:"center"}} className={classes.padding0}>
                                <Typography variant="h6" style={{color:"white"}}>Sin Elementos</Typography>
                            </Grid>}
                        </Grid>
                    </ExpansionPanelSummary>
                </ExpansionPanel>
            ))
        return Har
    }
    render() {

        const { isLoad, steps, date, open, div, display,openElements, divElements, displayElements} = this.state;
        //console.log(steps)
        const { classes } = this.props;
        if (isLoad===true) {
            return(
                <div>
    
                    <Typography
                        variant="caption"
                    >
                        <CircularProgress
                        variant="indeterminate"

                        size={12}
                        thickness={3}
                        
                    />
                        Cargando Información...
                    </Typography>
                </div>
            )
        }else{
            return(
                <div>
                    {/*MODAL ELEMENTOS PLUS*/}
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={openElements}
                    onClose={this.handleCloseElements}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width:"70%",
                        height:"80%",
                        top:"30px",
                        left:"17%",
                        padding: "2px"

                        
                    }}
                    closeAfterTransition
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                    >                                    
                        <Fade in={openElements}>
                            <PerfectScrollbar>
                                {divElements}
                            </PerfectScrollbar>
                        </Fade>
                </Modal>
                {/*MODAL ELEMENTOS PLUS*/}
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={open}
                    onClose={this.handleClose}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width:"70%",
                        height:"80%",
                        top:"30px",
                        left:"17%"
                    }}
                    closeAfterTransition
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                    >                                    
                        <Fade in={open}>
                            <PerfectScrollbar>
                            {div}
                            </PerfectScrollbar>
                        </Fade>
                </Modal>
                {this.createHar(date, steps)}
                </div>
            )
        }
        
        
    }
}



export default compose(withRouter, withStyles(styles))(ElementsPlus);